/* eslint-disable react/no-danger */
import PlayCircleOutlineOutlinedIcon from '@material-ui/icons/PlayCircleOutlineOutlined'
import ViewHeadlineOutlinedIcon from '@material-ui/icons/ViewHeadlineOutlined'
import { useRouter } from 'next/router'
import ViewTracker from '../../../../components/tracking/view-tracker'
import { H6, S1, Text } from '../../../../styles/typography'
import { ContentEl } from '../elements'
import CourseHomeStore from '../stores/course-home-store'

const Content = () => {
  const { asPath } = useRouter()
  const {
    data: { objectives, preRequisites, chapters },
  } = CourseHomeStore.useContainer()

  return (
    <ContentEl>
      <ViewTracker page={asPath} item='objectives' />

      <H6 className='title'>Course Objectives</H6>
      <div
        className='rtfContent'
        dangerouslySetInnerHTML={{ __html: objectives }}
      />

      <ViewTracker page={asPath} item='prerequisites' />
      <H6 className='title'>Course Prerequisites</H6>
      <div
        className='rtfContent'
        dangerouslySetInnerHTML={{ __html: preRequisites }}
      />

      <ViewTracker page={asPath} item='content' />
      <H6 className='title'>Course Content</H6>
      <div className='chapters'>
        {chapters.map((chapter, i) => (
          <div key={chapter.id} className='chapter'>
            <S1 className='index'>Chapter {i + 1}</S1>
            <Text className='name'>
              <ViewHeadlineOutlinedIcon /> <span>{chapter.name}</span>
            </Text>
            <div
              className='rtfContent'
              dangerouslySetInnerHTML={{ __html: chapter.description }}
            />
            <div className='lessons'>
              <Text>Lessons:</Text>
              {chapter.lessons.map((lesson) => (
                <div key={lesson.id} className='lesson'>
                  <Text className='name'>
                    <PlayCircleOutlineOutlinedIcon /> <span>{lesson.name}</span>
                  </Text>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </ContentEl>
  )
}

export default Content
